const COURSE_ROLE = {
  ADMIN: 'ADMIN',
  TUTOR: 'TUTOR'
};

export default COURSE_ROLE;
